import type { SVGProps } from 'react';
const SvgToys = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#toys_svg__a)">
      <path
        fill="currentColor"
        d="M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12Zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11Zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11Zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12Z"
      />
    </g>
    <defs>
      <clipPath id="toys_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgToys;
